import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { IUser } from '../models/user.model';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanActivate {
  private userService = inject(UserService);
  private router = inject(Router);

  canActivate(next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.userService.isLogged().then((user: IUser) => {
      if (user) {
        const allowedRoles = next.data.allowedRoles as Array<string>;
        const allowedPermissions = next.data.allowedPermissions as Array<string>;
        const canActivate = allowedRoles.includes(user.role);
        const canActivateByPermission = allowedPermissions.includes(user.account.permission);
        if (!canActivate && !canActivateByPermission) {
          this.router.navigate(['']);
        }
        return canActivate;
      }
      return false;
    });
  }
}
